export const COLORS = [
  { name: "Black", hex: "#141414", swatch: "#141414" },
  { name: "White", hex: "#F4F4F1", swatch: "#FFFFFF" },
  { name: "Red", hex: "#8B0000", swatch: "#8B1A1A" },
  { name: "Blue", hex: "#12213F", swatch: "#12213F" },
  { name: "Green", hex: "#0F3D2E", swatch: "#0F3D2E" },
  { name: "Yellow", hex: "#C9A227", swatch: "#D6A81E" },
];

const A = "https://customer-assets-v7afamib.emergentagent.net/job_watch-winder-pre/artifacts";

export const IMAGES = {
  hero: `${A}/z5zwpljk_ChatGPT%20Image%20Aug%2012%2C%202026%2C%2001_22_10%20PM.png`,
  logo: `/logo-trim.png`,
  logoDark: `/logo-trim-black.png`,
  motorBanner: `${A}/jngnnqyp_Mabuchi%20original%20motr.png`,
  cushionBanner: `${A}/4p8cbzzj_TRNCNDNC_Cushion.png`,
  controlBanner: `${A}/i4y0qx13_back%20side%20TNSDNCE.png`,
  linkBanner: `${A}/7qdpjvi9_ChatGPT%20Image%20Aug%2012%2C%202026%2C%2001_08_44%20PM.png`,
};

export const LIFESTYLE = {
  feature: `${A}/oa2vxfrp_black.png`,
  tiles: [
    `${A}/svc2ldvj_Gemini_Generated_Image_sqnd5msqnd5msqnd.png`,
    `${A}/n2wh0dju_Gemini_Generated_Image_sqnd5msqnd5msqnd%20%281%29.png`,
    `${A}/nlll3ai7_Gemini_Generated_Image_sqnd5msqnd5msqnd%20%282%29.png`,
    `${A}/gi55pwpt_Gemini_Generated_Image_sqnd5msqnd5msqnd%20%283%29.png`,
  ],
};

export const CHAPTERS = [
  { n: "01", title: "Mabuchi-driven motor", body: "A globally recognised name in precision motion control powers each unit — chosen for consistency over thousands of rotation cycles, not a one-time spec sheet number." },
  { n: "02", title: "Precise nylon gear assembly", body: "Reduction gearing translates motor speed into the slow, deliberate rotation an automatic movement actually needs — smooth engagement, minimal backlash, quiet operation." },
  { n: "03", title: "Adjustable calibration", body: "Direction and Turns Per Day are configurable to match your specific movement, rather than forcing every watch through the same fixed cycle." },
  { n: "04", title: "Adjustable cushion", body: "Side clicks lock the cushion in place while gentle spring compression adapts to your watch size — a secure hold without any pressure on the strap." },
];

export const STEPS = [
  { n: "Step 01", title: "Seat the watch", body: "Secure it on the cushion, facing the 12 o'clock resting position for an accurate read at a glance." },
  { n: "Step 02", title: "Set direction", body: "Choose clockwise, counter-clockwise, or alternating rotation to match your movement's requirement." },
  { n: "Step 03", title: "Dial in TPD", body: "Select Turns Per Day for your specific caliber — under-winding and over-winding are both avoidable." },
  { n: "Step 04", title: "Intermittent cycling", body: "The winder rotates in short bursts with rest between them, rather than spinning continuously — gentler on the movement over time." },
];

export const SPECS = [
  ["Compatibility", "All automatic types — Seiko, Casio, Timex, Citizen, Rolex, Breitling, Omega, TAG Heuer"],
  ["Power", "4 × AA (approx. 60–70 days) or AC mains via USB Type-C"],
  ["Multi-unit linking", "Transcendence Link — run multiple winders from one AC source"],
  ["Rotation modes", "Clockwise, counter-clockwise, or bi-directional"],
  ["TPD settings", "650 · 750 · 850 · 1,000 · 1,950 turns per day"],
  ["Cushion", "Omni cushion, fits 16.5–22cm / 6.5–8.5\" strap circumference"],
  ["Motor", "Ultra-quiet Mabuchi motor (Japan) with nylon gear assembly"],
];
